import { render, staticRenderFns } from "./MenuView.vue?vue&type=template&id=51d2a46c"
import script from "./MenuView.vue?vue&type=script&lang=js"
export * from "./MenuView.vue?vue&type=script&lang=js"
import style0 from "./MenuView.vue?vue&type=style&index=0&id=51d2a46c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51d2a46c')) {
      api.createRecord('51d2a46c', component.options)
    } else {
      api.reload('51d2a46c', component.options)
    }
    module.hot.accept("./MenuView.vue?vue&type=template&id=51d2a46c", function () {
      api.rerender('51d2a46c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/menu/MenuView.vue"
export default component.exports